import * as React from 'react';
import { SVGProps } from 'react';

const IconMoonSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.844 9.477a5.5 5.5 0 0 1-6.59-8.472 7 7 0 1 0 6.59 8.472z" />
  </svg>
);
export default IconMoonSizeS;
